import React, { useEffect, useState } from "react";
import "./MessageCodes.css";

const MessageA1 = (props) => {
    const [onSelect , setOnSelect] = useState(false)
    useEffect(()=>{
        props.setisSubscriber(false)
    })

    if (!props?.item?.text?.trim()) {
      return null;
    }
  
  return (
    <div className="a1-wrap" style={{ width: "fit-content" , margin : '6px',cursor: 'pointer' }}>
      <div
        className={
          !onSelect
            ? "chat-label action-tab "
            : "chat-label-select action-tab"
        }
        id="main-tab1"
        style={{ 
          color: props.disable && "grey" }}
        onClick={() => {
          if (!props.disable) {
            // props.handleClick(props.item.code, null, props.item.text);
            // props.setTextOnClick(props.item.text);
        
            const data = JSON.parse(localStorage.getItem("inputValue"));
            let input
            if(data && props?.item?.text === 'Submit'){
            localStorage.removeItem("inputValue"); 
             input = data?.key1
             props?.addMessages(input,props?.item?.code , props?.item?.text )
             setOnSelect(true)
            // }else if (!data && props?.item?.text === 'Submit'){
            //   return
            // }else if (data  && (props?.item?.text === 'Yes' || props?.item?.text === 'No' )){
            //   localStorage.removeItem("inputValue"); 
            //   input = data?.key1
            //   props?.addMessages(input,props?.item?.code ,props?.item?.text ,input )
            //   setOnSelect(true)
            //   return
            }else{
              input =props?.item?.text
              const checkUpdate = props?.item?.data ? JSON.parse(props.item.data) : undefined;
              props?.addMessages(null ,props?.item?.code ,props?.item?.text  ,null, checkUpdate?.action)
              setOnSelect(true)
            }
            localStorage.removeItem("ignoreError");
            localStorage.removeItem("inputValue");
            localStorage.removeItem("troubleShooting");
            localStorage.removeItem("inputBoxValue");
            localStorage.removeItem("inputValue1");
            
          }
        }}
      >
         {(() => {
            try {
            const parsed = JSON.parse(props?.item?.data || "{}");
            if (parsed?.button === "new" && parsed?.img) {
                return (
                    <img
                    src={parsed?.img}
                    alt={props?.item?.text}
                    style={{
                      width: "28px",
                      height: "24px",
                      marginRight : '4px',
                    }}
                  />
                  
                );
            }
            } catch {
            return null;
            }
            return null;
        })()}
        {props?.item?.text}
        {(() => {
            try {
            const parsed = JSON.parse(props?.item?.data || "{}");
            return parsed?.button === "new" ? (
                <div
                style={{
                    // position: "relative",
                    // top: "-16px",    // move above button
                    // right: "-12px",    // align with right corner
                    background: "red",
                    color: "white",
                    fontSize: "10px",
                    fontWeight: "bold",
                    padding: "2px 6px",
                    borderRadius: "10px",
                    whiteSpace: "nowrap",
                    marginLeft : '8px'
                }}
                >
                NEW
                </div>
            ) : null;
            } catch {
            return null;
                    }
           })()}
      </div>
    </div>
  );
};

export default MessageA1;
